import { Grid, IconButton, InputAdornment, TextField } from "@mui/material";
import { Controller } from "react-hook-form";
import { lang } from "../../Utils/lang";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { FormEventHandler, useState } from "react";

interface AddUserProps {
  control: any;
  handleSubmit: (payload: any) => FormEventHandler<HTMLFormElement>;
  handleSubmitData: () => void;
}
export default function AddUser(props: AddUserProps) {
  const [showPassword, setShowPassword] = useState(false);
  const { control, handleSubmit, handleSubmitData } = props;

  // Function to toggle password visibility
  const handleClickShowPassword = () =>
    setShowPassword((prev: boolean) => !prev);

  // Function to prevent mouse down default behavior
  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => event.preventDefault();

  return (
    <Grid item sx={{ flex: 2, mt: 4, mb: 2 }}>
      <form
        onSubmit={handleSubmit(handleSubmitData)}
        method="get"
        id="checkUserData"
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
        }}
      >
        <Controller
          name="username"
          defaultValue=""
          control={control}
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <TextField
              onChange={onChange}
              fullWidth
              style={{
                marginBottom: 15,
              }}
              value={value}
              error={!!error}
              helperText={error?.message}
              id="username"
              label={lang.username}
              size="small"
              variant="outlined"
            />
          )}
        />
        <Controller
          name="email"
          defaultValue=""
          control={control}
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <TextField
              onChange={onChange}
              fullWidth
              style={{
                marginBottom: 15,
              }}
              value={value}
              error={!!error}
              helperText={error?.message}
              id="email"
              label={lang.email}
              size="small"
              variant="outlined"
            />
          )}
        />
        <Controller
          name="password"
          defaultValue=""
          control={control}
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <TextField
              onChange={onChange}
              fullWidth
              style={{
                marginBottom: 15,
              }}
              value={value}
              error={!!error}
              helperText={error?.message}
              id="password"
              label={lang.password}
              size="small"
              variant="outlined"
              type={showPassword ? "text" : "password"}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          )}
        />
      </form>
    </Grid>
  );
}
